import React, { memo } from 'react';
import clsx from 'clsx';

import './Emoji.scss';

const Emoji = ({ label, symbol, className }) => (
  <span
    className={clsx('common-emoji', className)}
    role='img'
    aria-label={label ?? ''}
    aria-hidden={label ? 'false' : 'true'}>
    {symbol}
  </span>
);

export default memo(Emoji);
